<template>
  <v-card>

    <v-tabs v-model="abaAtual" background-color="white" centered>
      <v-tab>Convocação</v-tab>
      <v-tab>Implantação</v-tab>
    </v-tabs>

    <v-card-text>
      <v-tabs-items v-model="abaAtual">
        <v-tab-item>
          <div>
            <Consulta
                ref="filtroConsulta"
                titulo="Convocados para mudança Especial de Curso"
                :consulta-callback="consulta"
                :parametros="paramsFiltro"
                :colunas="headers"
                :ordenacao-colunas="sortBy"
            >
              <template v-slot:areaParametros>
                <v-row dense>
                  <v-col cols="6">
                    <v-autocomplete
                        v-model="paramsFiltro.processoOid"
                        :rules="[campoObrigatorioRule]"
                        :items="processos"
                        clearable
                        dense
                        item-text="nome"
                        item-value="oid"
                        label="Processo *"
                        outlined
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                        v-model="paramsFiltro.nome"
                        dense
                        label="Nome"
                        name="nome"
                        outlined
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                        v-model="paramsFiltro.cpf"
                        v-mask="'###########'"
                        :counter="11"
                        dense
                        label="CPF"
                        maxlength="11"
                        name="cpf"
                        outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
              </template>
              <template v-slot:item.convocado="{ item }">
                {{ item.convocado === true ? 'Sim' : item.convocado === false ? 'Não' : '-' }}
              </template>
              <template v-slot:acoesMenu = {item}>
                <v-btn block text @click="alterarStatusConvocacao(item.oid, item.convocado)">
                  {{ item.convocado == true ? 'Desconvocar' : 'Convocar'}}
                </v-btn>
              </template>
            </Consulta>
          </div>
        </v-tab-item>

        <v-tab-item>
          <v-card flat class="mt-6 pa-4 text-center">

            <v-icon size="48" color="primary" class="mb-4">mdi-database-export</v-icon>
            <h3 class="text-h5 mb-2">Processamento de Implantação</h3>
            <p class="text-body-2 grey--text mb-6">
              Selecione o processo desejado para visualizar os candidatos e clique em "Implantar" para iniciar o envio para o SIGA.
            </p>

            <v-row justify="center" class="mb-4">
              <v-col cols="12" md="6">
                <v-autocomplete
                    v-model="processoImplantacao"
                    :items="processos"
                    item-text="nome"
                    item-value="oid"
                    label="Selecione o Processo"
                    outlined
                    dense
                    clearable
                ></v-autocomplete>
              </v-col>
            </v-row>

            <v-row justify="center" class="mt-8 mb-2">
              <v-btn
                  color="primary"
                  x-large
                  :disabled="candidatosAcompanhamento.length === 0 || carregandoImplantacao"
                  :loading="carregandoImplantacao"
                  @click="iniciarImplantacao"
              >
                Implantar Candidatos
              </v-btn>
            </v-row>

            <v-expand-transition>
              <div v-if="processoImplantacao" class="mt-10 text-left">
                <v-divider class="mb-4"></v-divider>

                <div class="d-flex justify-space-between align-center mb-4">
                  <h4 class="text-h6">Acompanhamento</h4>
                  <v-btn
                      color="secondary"
                      text
                      @click="carregarStatusCandidatos"
                      :loading="atualizandoTabela"
                  >
                    <v-icon left>mdi-refresh</v-icon> Atualizar Status
                  </v-btn>
                </div>

                <v-data-table
                    :headers="headersAcompanhamento"
                    :items="candidatosAcompanhamento"
                    :loading="atualizandoTabela"
                    hide-default-footer
                    disable-pagination
                    class="elevation-1"
                    no-data-text="Nenhum candidato apto encontrado para este processo."
                    height="400px"          fixed-header            >
                  <template v-slot:item.status="{ item }">

                    <v-chip v-if="item.implantado" color="success" small dark>
                      <v-icon left small>mdi-check-circle</v-icon> Implantado
                    </v-chip>

                    <v-tooltip bottom v-else-if="item.motivoFalha">
                      <template v-slot:activator="{ on, attrs }">
                        <v-chip color="error" small dark v-bind="attrs" v-on="on">
                          <v-icon left small>mdi-alert-circle</v-icon> Erro
                        </v-chip>
                      </template>
                      <span>{{ item.motivoFalha }}</span>
                    </v-tooltip>

                    <v-chip v-else color="info" small dark>
                      <v-icon left small>mdi-timer-sand</v-icon> Stand-By
                    </v-chip>

                  </template>

                  <template v-slot:item.motivoFalha="{ item }">
                    <span v-if="item.motivoFalha" class="error--text text-caption font-weight-bold">
                      {{ item.motivoFalha }}
                    </span>
                    <span v-else class="grey--text">—</span>
                  </template>

                </v-data-table>

              </div>
            </v-expand-transition>

          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </v-card>
</template>

<script>
import implantacaoMudancaCursoService from "@/services/implantacaoMudancaCurso.service";
import processoService from '@/services/processo.service';
import Consulta from "@/components/pages/admin/consultas/Consulta.vue";
import rules from "@/commons/rules";
import { mapActions } from "vuex";

export default {
  name: 'MudancaCurso',
  components: { Consulta },

  data() {
    return {
      abaAtual: 0,
      processos: [],

      //CONVOCAÇÃO
      consulta: implantacaoMudancaCursoService.filtraConvocadosMudancaCurso,
      headers: [
        { text: "Nome", value: "nome" },
        { text: "CPF", value: "cpf" },
        { text: "Matrícula", value: "matricula" },
        { text: "Opção", value: "nomeOpcao" },
        { text: "Convocado", value: "convocado" },
        { text: "Classificação Geral Oid", value: "oid" },
      ],
      paramsFiltro: {
        processoOid: null,
        nome: '',
        cpf: '',
        implantado: false
      },
      sortBy: ['convocado'],

      //IMPLANTAÇÃO
      processoImplantacao: null,
      carregandoImplantacao: false,
      atualizandoTabela: false,

      headersAcompanhamento: [
        { text: "Matrícula", value: "matricula" },
        { text: "Nome", value: "nome" },
        { text: "Status", value: "status", align: "center", sortable: false },
        { text: "Detalhe do Erro", value: "motivoFalha" }
      ],
      candidatosAcompanhamento: [],

      intervaloAtualizacao: null
    };
  },

  watch: {
    processoImplantacao(novoValor) {
      if (novoValor) {
        this.carregarStatusCandidatos(false);
      } else {
        this.candidatosAcompanhamento = [];
        if (this.intervaloAtualizacao) clearInterval(this.intervaloAtualizacao);
      }
    },


    abaAtual(novaAba) {
      if (novaAba === 1 && this.processoImplantacao) {
        this.carregarStatusCandidatos(true);
      }
    }
  },

  async created() {
    let loader = this.$loading.show();
    try {
      const response = await processoService.recuperarProcessosConsultaPorTipoProcessoCodigo("MUD");
      this.processos = response.data;
    } catch (e) {
      console.error(e);
    } finally {
      loader.hide();
    }
  },

  async mounted() {
    this.$refs.filtroConsulta.mostrarResultado = true;
    await this.$refs.filtroConsulta.consultar();
  },

  beforeDestroy() {
    if (this.intervaloAtualizacao) clearInterval(this.intervaloAtualizacao);
  },

  methods: {
    ...rules,
    ...mapActions("avisos", ["exibirAviso"]),

    async alterarStatusConvocacao(processoOid, status) {
      let loader = this.$loading.show();
      try {
        const convocacao = status !== true;
        await implantacaoMudancaCursoService.alterarStatusConvocacao(processoOid, convocacao);
        await this.$refs.filtroConsulta.consultar();
      } catch (error) {
        this.exibirAviso({ mensagem: "Não foi possível alterar a convocação.", tipo: "error" });
      } finally {
        loader.hide();
      }
    },

    async iniciarImplantacao() {
      this.carregandoImplantacao = true;
      try {
        await implantacaoMudancaCursoService.enviarParaImplantacao(this.processoImplantacao);

        this.exibirAviso({
          mensagem: "Implantação iniciada. Candidatos foram enviados para a fila.",
          tipo: "success"
        });

        if (this.intervaloAtualizacao) clearInterval(this.intervaloAtualizacao);
        this.intervaloAtualizacao = setInterval(() => {
          this.carregarStatusCandidatos(true);
        }, 5000);

      } catch (error) {
        this.exibirAviso({ mensagem: "Falha ao iniciar implantação em lote.", tipo: "error" });
      } finally {
        this.carregandoImplantacao = false;
      }
    },

    async carregarStatusCandidatos(isBackground = false) {
      if (!isBackground) this.atualizandoTabela = true;

      try {
        const params = {
          processoOid: this.processoImplantacao,
          nome: '',
          cpf: '',
          implantado: null
        };

        const response = await implantacaoMudancaCursoService.filtraConvocadosMudancaCurso(params, 0, 1000, []);

        let todosCandidatos = response.data.elementos || [];

        this.candidatosAcompanhamento = todosCandidatos.filter(c => c.convocado === true);

      } catch (error) {
        console.error("Erro ao atualizar status", error);
      } finally {
        this.atualizandoTabela = false;
      }
    }
  }
}
</script>